<script lang="ts">
  import { Button, Card, CardBody, CardHeader, Col, Input, Label } from "sveltestrap";
  import { Filter, FindCourse } from "../../../utils/Constant/Constant";
  import FeatherIcons from "svelte-feather-icon";
  import {findCourse} from "../../../Data/Miscellaneous/LearningList"
  let open:boolean = true
</script> 
<Col xl="12">
    <Card>
      <CardHeader>
        <h5 class="mb-0 p-0">
          <Button class="btn-link" color="transparent" on:click={()=> open = !open}>{FindCourse}</Button>
        </h5>
      </CardHeader>
      <div class="collapse {open ? "show" : ""}" >
        <CardBody class="filter-cards-view animate-chk">
          <div class="job-filter">
            <div class="faq-form">
              <Input type="text" placeholder="Search.." />
              <FeatherIcons class="search-icon" icon="search" />
            </div>
          </div>
          {#each findCourse as findItem}
            <div class="checkbox-animated {findItem.class}">
                <div class="learning-header">
                    <span class="f-w-600">{findItem.title}</span>
                </div>
                {#each findItem.check as checkItem}
                    <Label class="d-block" for={checkItem.id}>
                        <input class="{checkItem.type}_animated" id={checkItem.id} type={checkItem.type} name={checkItem.names}/>    {checkItem.name}
                    </Label>
                {/each}
            </div>
          {/each}
          <Button color="primary" class="text-center">{Filter}</Button>
        </CardBody>
      </div>
    </Card>
</Col>